import Axios from './axios_wrapper'

export function getSurgeonReports({id, filters = ''}) {
  return Axios({
    url: `/surgeons/${id}/reports?${filters}`,
    method: 'GET'
  })
}

export function getSurgeonReportsById({id, report_id, filters}) {
  return Axios({
    url: `/surgeons/${id}/reports/${report_id}?${filters}`,
    method: 'GET'
  })
}

export function getSurgeonPhinReport({id}) {
  return Axios({
    url: `/surgeons/${id}/reports/static/phin`,
    method: 'GET'
  })
}

export function getDistributorReportById({report_id, filters }) {
  if(!filters) filters = ''

  return Axios({
    url: `/distributor/reports/${report_id}?${filters}`,
    method: 'GET'
  })
}

export function getSurgeonScore({id}) {
  return Axios({
    url: `/surgeons/${id}/scores`,
    method: 'GET'
  })
}

export function getAdminReports({filters = ''}) {
  return Axios({
    url: `/admin/reports?${filters}`,
    method: 'GET'
  })
}
export function getAdminReportById({report_id, filters}) {
  return Axios({
    url: `/admin/reports/${report_id}?${filters}`,
    method: 'GET'
  })
}

export function getAdminPhinReport() {
  return Axios({
    url: `/admin/csv/reports/static/phin`,
    method: 'GET'
  })
}

export function getDistributorReports({filters}) {
  if(!filters) filters = ''
  return Axios({
    url: `/distributor/reports?${filters}`,
    method: 'GET'
  })
}


export function getHospitalAdminReports({filters}) {
  if(!filters) filters = ''
  return Axios({
    url: `/hospital_admin/reports?${filters}`,
    method: 'GET'
  })
}

export function getHospitalAdminReportsById({report_id, filters }) {
  if(!filters) filters = ''

  return Axios({
    url: `/hospital_admin/reports/${report_id}?${filters}`,
    method: 'GET'
  })
}

export function getGlobalReports() {
  return Axios({
    url: '/global_reports',
    method: 'GET'
  })
}

export function getGlobalReportsById({report_id}) {
  return Axios({
    url: `/global_reports/${report_id}`,
    method: 'GET'
  })
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/reports.js
// module id = null
// module chunks = 